import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import Sidebar from "../comman/Sidebar";
import Navbar from "../comman/Navbar";
import BillingStatementMenu from "../comman/BillingStatementMenu";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_ALL_CUSTOMERS_URL,
  GET_ALL_PROJECT_FILTER_URL,
  GET_BILLING_REVIEW_API,
} from "../../constants/ApiRoute";
import { authHeader } from "../comman/MainFunction";
import API from "../comman/API";
import { FormControl, InputAdornment } from "@mui/material";
import moment from "moment";
import BillingNodata from "../../images/billing-nodata.svg";
import NoRecordFound from "../comman/NoRecordFound";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import { useLocation, useNavigate } from "react-router";

const filterInitial = {
  customerStatus: "",
  projectStatus: "",
  userId: "",
  projectId: "",
};
const style = document.createElement("style");
style.innerHTML = `
  li.MuiAutocomplete-option {
    font-size: 14px !important;
    font-weight: 400;
  }
`;
document.head.appendChild(style);

const BillingReview = () => {
  const loading = false;
  const activeUserCheck = true;
  const isBillingStatementSearch = true;
  const billPeriod = 15;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [count, setCount] = useState(100);
  const [page, setPage] = useState(0);

  const [filter, setFilter] = React.useState(filterInitial);
  const [userList, setUserList] = useState([]);
  const userListSel = deCryptFun(useSelector((s) => s.AllCustomerListReducer));
  const [visibleRows, setVisibleRows] = useState(5);
  const [billingStatmentLoading, setBillingStatementLoading] = useState(true);
  const [projectList, setProjectList] = useState([]);
  const [projectListDropdown, setProjectListDropdown] = useState([]);
  const [statementList, setStatementList] = useState([]);
  const [billingStateOrderBy, setBillingStateOrderBy] = useState("");
  const [billingStateOrder, setBillingStateOrder] = useState("asc");
  console.log(statementList, "setStatementListsetStatementList");
  console.log(filter, "filterfilterfilter");

  const handleLocationSortRequest = (property) => {
    const isAsc =
      billingStateOrderBy === property && billingStateOrder === "asc";
    if (billingStateOrderBy === property && billingStateOrder === "desc") {
      setBillingStateOrder("");
      setBillingStateOrderBy("");
    } else {
      setBillingStateOrder(isAsc ? "desc" : "asc");
      setBillingStateOrderBy(property);
    }
  };

  const getLocationSortIcon = (orderByValue) => {
    if (billingStateOrderBy === orderByValue) {
      return billingStateOrder === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };
  const allPeriods = Array.from({ length: 10 }, (_, i) => ({
    billingDate: `Period ${i + 1}`,
    hours: (i + 1) * 2,
    dayRate: 100 + i * 10,
    miles: 50 + i * 5,
    mileageRate: 0.5 + i * 0.1,
    perDiem: 20 + i * 2,
    statusId: (i % 4) + 1,
  }));
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && visibleRows < allPeriods.length) {
      setVisibleRows((prev) => Math.min(prev + 5, allPeriods.length));
    }
  };

  const handleFilterChange = (event, value) => {
    if (location.search) {
      navigate("/billing-review", { replace: true });
    }
    setBillingStatementLoading(true);
    setStatementList([]);
    const { name, value: inputValue } = event.target;

    if (name === "projectId") {
      const selectedProject = projectList?.find(
        (element) => element.ProjectId === inputValue
      );
      setFilter((prevState) => ({
        ...prevState,
        projectId: inputValue,
        filterValues: {},
      }));
    }

    if (name === "userId") {
      setProjectList([]);
      setProjectListDropdown([]);

      setFilter((prevState) => ({
        ...prevState,
        userId: inputValue,
        projectId: "",
        projectStatus: "",
        filterValues: {},
      }));
      getProjectList(inputValue);
    }

    console.log(name, value, "akskajhsajshj");

    if (!name && value) {
      const selectedUser = userList.find((user) => user.UserId === value);

      if (selectedUser) {
        setFilter((prevState) => ({
          ...prevState,
          userId: value,
          projectId:"",
          projectStatus: "",
          filterValues: {},
        }));
        getProjectList(value);
      }
    } else {
      setFilter((prevState) => ({
        ...prevState,
        userId: "",
        filterValues: {},
      }));
      setProjectList([]);
      setProjectListDropdown([]);
    }
  };

  const handleFilterChange1 = (event, value) => {
    // Handle project change and update filter state as needed
    if (location.search) {
      navigate("/billing-review", { replace: true });
    }
    setBillingStatementLoading(true);
    setStatementList([]);
    if (value) {
      setFilter((prevState) => ({
        ...prevState,
        projectId: value.ProjectId,
        filterValues: {},
      }));
      getBillingStatementDetails(value.ProjectId);
    } else {
      // Reset filter values if no project is selected
      setFilter((prevState) => ({
        ...prevState,
        projectId: "",
        filterValues: {},
      }));
    }
  };

  const getProjectList = async (customerId, projectId) => {
    setBillingStatementLoading(true);
    if (customerId) {
      let data = {
        count: count,
        offset: page,
        customerId: customerId,
      };

      const config = {
        method: "GET",
        url: GET_ALL_PROJECT_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };
      setBillingStatementLoading(true);
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);

        if (parsedResponse.data && parsedResponse.data.length > 0) {
          const filteredData = parsedResponse.data.map((item) => ({
            Name: item.Name,
            ProjectId: item.ProjectId,
            BillingPeriod: item.BillingPeriod,
            Active: item.Active,
          }));
          setProjectList(filteredData || []);
          setProjectListDropdown(filteredData);
        } else {
          setProjectList([]);
          setProjectListDropdown([]);
        }
        if (projectId) {
          getBillingStatementDetails(projectId);
        }
        setBillingStatementLoading(false);
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
        }
        setProjectList([]);
        return null; // Return null on error
      }
    } else {
      setProjectList([]);
      setProjectListDropdown([]);
      setBillingStatementLoading(false);
    }
  };

  const getCustomersList = async () => {
    console.log("Calling getAllCustomersList");
    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_ALL_CUSTOMERS_URL,
    };
    try {
      console.log("Calling getAllCustomersList");
      const response = await API(config);
      console.log(response, "aaaaaaaaaaaaaaaa");
      let decryptedResponse = deCryptFun(response.data);
      console.log("Calling getAllCustomersList", decryptedResponse);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        setUserList(parsedResponse.data);
      } else {
        setUserList([]);
      }
      setBillingStatementLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
      return null; // Return null on error
    }
  };

  const getBillingStatementDetails = async (value) => {
    setBillingStatementLoading(true);
    let data = {
      projectId: value || filter?.projectId,
    };

    const config = {
      method: "GET",
      url: GET_BILLING_REVIEW_API,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    setBillingStatementLoading(true);
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log(parsedResponse, "parseeeeeeee");
      if (parsedResponse.status === "Success") {
        const sortedDetails = [
          ...(parsedResponse?.billingStatementDetails || []),
        ].sort((a, b) => {
          const startA = moment.utc(a.BillingStart);
          const startB = moment.utc(b.BillingStart);
          const endA = moment.utc(a.BillingEnd);
          const endB = moment.utc(b.BillingEnd);

          if (startA.isBefore(startB)) return -1;
          if (startA.isAfter(startB)) return 1;

          // If BillingStart is equal, compare BillingEnd
          if (endA.isBefore(endB)) return -1;
          if (endA.isAfter(endB)) return 1;

          return 0;
        });

        // Set the sorted data back into the statement list
        setStatementList({
          ...parsedResponse,
          billingStatementDetails: sortedDetails,
        });

        // setStatementList(parsedResponse);
        return parsedResponse;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        setBillingStatementLoading(false);
        setStatementList([]);
      }
      return null; // Return null on error
    } finally {
      setBillingStatementLoading(false);
    }
  };

  const handleCustomerProjectStatusChange = async (name, val) => {
    if (location.search) {
      navigate("/billing-review", { replace: true });
    }
    setBillingStateOrderBy("")
    setBillingStateOrder('asc')
    setBillingStatementLoading(true);
    setStatementList([]);

    let value = "";
    if (val === "yes") value = true;
    else if (val === "no") value = false;
    else if (val === "all") value = ""; // default for All

    if (name === "customerStatus") {
      // Reset filters
      setFilter((prevState) => ({
        ...prevState,
        userId: "",
        projectId: "",
        projectStatus: "",
        filterValues: {},
      }));
      setProjectList([]);
      setProjectListDropdown([]);

      // 📡 Call the API to get full customer list
      const config = {
        method: "GET",
        headers: authHeader(),
        url: GET_ALL_CUSTOMERS_URL,
      };

      try {
        const response = await API(config);
        const decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        const fullCustomerList = parsedResponse.data || [];

        // 🧹 Filter based on checkbox
        let filteredList = [];
        if (value === "") {
          filteredList = fullCustomerList; // All
        } else if (value === true) {
          filteredList = fullCustomerList.filter((item) => item.Active === 1); // Active
        } else if (value === false) {
          filteredList = fullCustomerList.filter((item) => item.Active === 0); // Inactive
        }

        // 💾 Update the list in dropdown
        setUserList(filteredList);
      } catch (error) {
        console.error("Error fetching customer list", error);
      }
    } else if (name === "projectStatus") {
      setFilter((prevState) => ({
        ...prevState,
        projectId: "",
        filterValues: {},
      }));

      // ✅ Re-fetch latest project list from API first
      if (filter.userId) {
        let data = {
          count: count,
          offset: page,
          customerId: filter.userId,
        };

        const config = {
          method: "GET",
          url: GET_ALL_PROJECT_FILTER_URL,
          headers: authHeader(),
          params: {
            webString: enCryptFun(JSON.stringify(data)),
          },
        };

        try {
          const response = await API(config);
          const decryptedResponse = deCryptFun(response.data);
          const parsedResponse = JSON.parse(decryptedResponse);
          const fullProjectList = parsedResponse.data || [];

          const filteredProjects =
            value === ""
              ? fullProjectList
              : fullProjectList.filter(
                  (project) => project.Active === (value ? 1 : 0)
                );

          setProjectListDropdown(fullProjectList); // store full copy
          setProjectList(filteredProjects); // apply filter now
        } catch (error) {
          console.error("Error fetching project list", error);
          setProjectList([]);
          setProjectListDropdown([]);
        }
      } else {
        // If no customer selected, just clear project list
        setProjectList([]);
        setProjectListDropdown([]);
      }
    }

    // ✅ Update the customerStatus in the filter
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setBillingStatementLoading(false);
  };

  useEffect(() => {
    console.log("useEffect triggered");
    getCustomersList();
  }, []);

  const sortedLocationList = useMemo(() => {
    statementList?.billingStatementDetails?.forEach((statement) => {
      statement.Miles = statement.Miles ? statement.Miles : 0;
      statement.PerDiem = statement.PerDiem
        ? parseFloat(statement.PerDiem).toFixed(2)
        : (0).toFixed(2);
      statement.StatusID = statement.StatusID ? statement.StatusID : 0;
    });

    if (billingStateOrderBy) {
      return [...statementList?.billingStatementDetails || []].sort((a, b) => {
        if (
          billingStateOrderBy === "ID" ||
          billingStateOrderBy === "Hours" ||
          billingStateOrderBy === "DayRate" ||
          billingStateOrderBy === "Miles" ||
          billingStateOrderBy === "Expenses" ||
          billingStateOrderBy === "PerDiem" ||
          billingStateOrderBy === "Total"
          // billingStateOrderBy === "StatusID"
        ) {
          const valueA = parseFloat(a[billingStateOrderBy]);
          const valueB = parseFloat(b[billingStateOrderBy]);
          console.log(valueA, valueB, "valueA - valueB");
          return billingStateOrder === "asc"
            ? valueA - valueB
            : valueB - valueA;
        } else {
          const valueA = a[billingStateOrderBy];
          const valueB = b[billingStateOrderBy];

          // Check if values are strings before calling toLowerCase
          const strA =
            typeof valueA === "string"
              ? valueA.toLowerCase()
              : String(valueA || "");
          const strB =
            typeof valueB === "string"
              ? valueB.toLowerCase()
              : String(valueB || "");

          if (billingStateOrder === "asc") {
            return strA < strB ? -1 : strA > strB ? 1 : 0;
          } else {
            return strA > strB ? -1 : strA < strB ? 1 : 0;
          }
        }
      });
    }
    return statementList?.billingStatementDetails;
  }, [statementList, billingStateOrderBy, billingStateOrder]);

  const params = new URLSearchParams(location.search);

  const customerId = params.get("cusId");
  const projectId = params.get("projId");

  useEffect(() => {
    if (customerId && projectId) {
      setFilter((prev) => ({
        ...prev,
        userId: customerId,
        projectId: projectId,
        projectStatus: "",
        filterValues: {},
      }));

      getProjectList(customerId, projectId);
    }
  }, [customerId, projectId]);

  return (
    <Box sx={{ display: "-webkit-box" }}>
      <Sidebar higlightSide={"4"} />
      <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
        <Navbar title="Billing Review" backFlag={false} backRoute={""} />
        {/* Filter Section */}
        <Box className="secound-bg-box user-log">
          {/* <p
            style={{ marginBottom: "25px", fontWeight: "400" }}
            className="label"
          >
            Select a customer & project to view, edit, and create billing
            statements.
            <span
              style={{
                fontSize: "16px",
                cursor: "pointer",
                position: "absolute",
                color: "#898989",
              }}
              className="material-symbols-outlined"
            >
              help
            </span>
          </p> */}

          <Grid container>
            <Grid item xs={12} md={6} sx={{ pr: { xs: "0", md: "30px" } }}>
              <Box className="billing-active-checkbox">
                <p className="label oh-label">Customer</p>
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="customerStatus"
                      onChange={() =>
                        handleCustomerProjectStatusChange(
                          "customerStatus",
                          "all",
                          console.log("CALLLLINGGGGG")
                        )
                      }
                      checked={filter?.customerStatus === "" ? true : false}
                      sx={{ color: "gray" }}
                      disabled={billingStatmentLoading == true}
                    />
                  }
                  label="All"
                />
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="customerStatus"
                      onChange={() =>
                        handleCustomerProjectStatusChange(
                          "customerStatus",
                          "yes"
                        )
                      }
                      checked={filter?.customerStatus === true ? true : false}
                      sx={{ color: "gray" }}
                      disabled={billingStatmentLoading == true}
                    />
                  }
                  label="Active"
                />
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="customerStatus"
                      onChange={() =>
                        handleCustomerProjectStatusChange(
                          "customerStatus",
                          "no"
                        )
                      }
                      checked={filter?.customerStatus === false ? true : false}
                      sx={{ color: "gray" }}
                      disabled={billingStatmentLoading == true}
                    />
                  }
                  label="Inactive"
                />
              </Box>
              <FormControl
                sx={{
                  height: "25px !imporatant",
                  color: "#212121 !important",
                  fontSize: "14px !important",
                  width: "100%",
                }}
                variant="standard"
                disabled={billingStatmentLoading}
              >
                <Autocomplete
                  className="review-input"
                  sx={{
                    width: "100%",
                    fontSize: "14px !important",
                    // "& .MuiAutocomplete-inputRoot": {
                    //   paddingRight: "10px !important",
                    // },
                    "& .MuiAutocomplete-input": {
                      color: "#212121 !important",
                      fontSize: "14px !important",
                      // height: '25px !important'
                    },
                  }}
                  options={userList || []}
                  getOptionLabel={(option) => option.Name || ""}
                  onChange={(event, value) =>
                    handleFilterChange(event, value?.UserId)
                  }
                  value={
                    Array.isArray(userList)
                      ? userList.find((user) => user.UserId == filter.userId) ||
                        null
                      : null
                  }
                  disableClearable
                  clearOnEscape={false}
                  loading={billingStatmentLoading}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Customer"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                            {filter.userId && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  aria-label="close"
                                  color="inherit"
                                  onClick={() => {
                                    // Reset projectId when remove button is clicked
                                    setFilter((prevState) => ({
                                      ...prevState,
                                      userId: "",
                                      projectId: "",
                                      projectStatus: "",
                                      filterValues: {},
                                    }));
                                  }}
                                >
                                  <HighlightOffIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            )}
                          </>
                        ),
                      }}
                      renderOption={(props, option) => (
                        <li
                          style={{
                            color: "#212121 !important",
                            fontSize: "14px",
                            fontWeight: 400,
                          }}
                          {...props}
                          key={option.UserId}
                        >
                          {option.Name}
                        </li>
                      )}
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid
              item
              sx={{
                pl: { xs: "0", md: "30px" },
                opacity:
                  billingStatmentLoading == true || filter?.userId === ""
                    ? 0.5
                    : 1, // Reduce opacity to indicate disabled state
                pointerEvents:
                  billingStatmentLoading == true || filter?.userId === ""
                    ? "none"
                    : "auto", // Prevent interaction
                pl: { xs: "0", md: "30px" },
              }}
              xs={12}
              md={6}
            >
              <Box className="billing-active-checkbox">
                <p className="label oh-label">Project</p>
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="projectStatus"
                      onChange={() =>
                        handleCustomerProjectStatusChange(
                          "projectStatus",
                          "all"
                        )
                      }
                      checked={
                        !activeUserCheck || filter?.projectStatus === ""
                          ? true
                          : false
                      }
                      sx={{ color: "gray" }}
                      disabled={
                        activeUserCheck == undefined ||
                        billingStatmentLoading == true ||
                        filter?.userId === ""
                      } // Conditionally disable
                    />
                  }
                  label="All"
                />
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="projectStatus"
                      onChange={() =>
                        handleCustomerProjectStatusChange(
                          "projectStatus",
                          "yes"
                        )
                      }
                      checked={
                        activeUserCheck && filter?.projectStatus === true
                          ? true
                          : false
                      }
                      sx={{ color: "gray" }}
                      disabled={
                        activeUserCheck == undefined ||
                        billingStatmentLoading == true ||
                        filter?.userId === ""
                      }
                    />
                  }
                  label="Active"
                />
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      name="projectStatus"
                      onChange={() =>
                        handleCustomerProjectStatusChange("projectStatus", "no")
                      }
                      checked={
                        activeUserCheck && filter?.projectStatus === false
                          ? true
                          : false
                      }
                      sx={{ color: "gray" }}
                      disabled={
                        activeUserCheck == undefined ||
                        billingStatmentLoading == true ||
                        filter?.userId === ""
                      }
                    />
                  }
                  label="Inactive"
                />
              </Box>
              <FormControl
                sx={{ width: "100%" }}
                variant="standard"
                disabled={
                  billingStatmentLoading == true || filter?.userId === ""
                }
              >
                <Autocomplete
                  className="review-input"
                  sx={{
                    width: "100%",
                    fontSize: "14px !important",
                    // "& .MuiAutocomplete-inputRoot": {
                    //   paddingRight: "10px !important",
                    // },
                    "& .MuiAutocomplete-input": {
                      color: "#212121 !important",
                      fontSize: "14px !important",
                      // height: '25px !important'
                    },
                  }}
                  options={projectList || []}
                  getOptionLabel={(option) => option.Name}
                  onChange={(event, value) => handleFilterChange1(event, value)}
                  value={
                    Array.isArray(projectList)
                      ? projectList.find(
                          (project) => project.ProjectId == filter.projectId
                        ) || null
                      : null
                  }
                  loading={billingStatmentLoading}
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search Project"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}
                            {filter.projectId && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  aria-label="close"
                                  color="inherit"
                                  onClick={() => {
                                    // Reset projectId when remove button is clicked
                                    setFilter((prevState) => ({
                                      ...prevState,
                                      projectId: "",
                                      filterValues: {},
                                    }));
                                  }}
                                >
                                  <HighlightOffIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            )}
                          </>
                        ),
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.ProjectId === value.ProjectId
                      }
                      renderOption={(props, option) => (
                        <li
                          style={{
                            color: "#212121 !important",
                            fontSize: "14px",
                            fontWeight: 400,
                          }}
                          {...props}
                          key={option.ProjectId}
                        >
                          {option.Name}
                        </li>
                      )}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        {/* Loading Spinner Section */}
        {loading && (
          <Box
            sx={{ background: "#fff", padding: "25px 24px", mt: "15px" }}
            className="secound-bg-box user-log"
          >
            <Grid container>
              <Grid item xs={12} md={12} align="center">
                <CircularProgress disableShrink />
              </Grid>
            </Grid>
          </Box>
        )}

        {/* Placeholder Table Section */}
        {billingStatmentLoading ? (
          <Box
            sx={{ background: "#fff", padding: "25px 24px", mt: "15px" }}
            className="secound-bg-box user-log"
          >
            <Grid container>
              <Grid xs={12} md={12} colSpan={7} align="center">
                <CircularProgress disableShrink />
              </Grid>
            </Grid>
          </Box>
        ) : filter?.userId != "" && filter?.projectId != "" ? (
          <Box
            sx={{ background: "#fff", padding: "25px 24px", mt: "15px" }}
            className="secound-bg-box user-log"
          >
            <Grid container>
              <Grid item xs={12} md={12}>
                {/* <Stack
                  sx={{ float: "left", mt: "10px" }}
                  direction="row"
                  spacing={1}
                  alignItems="left"
                >
                  <p className="label oh-label">
                    Selected Project has {billPeriod} days Billing Period
                  </p>
                </Stack> */}

                <Stack
                  sx={{
                    float: { xs: "left", md: "right" },
                    marginTop: "0px",
                    marginBottom: "20px",
                  }}
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1}
                >
                  {/* <Button variant="contained" className="clear-btn">
                    Clear Filter
                  </Button> */}
                  <Box className="invoice-total">
                    <Typography className="invoice-total-title">
                      Total:
                    </Typography>
                    <Typography className="invoice-total-amount">
                      $
                      {parseFloat(statementList?.overAllTotal || 0)?.toFixed(2)}
                    </Typography>
                  </Box>
                </Stack>

                {statementList?.billingStatementDetails?.length > 0 ? (
                  <TableContainer
                    className="billing-table"
                    sx={{ boxShadow: "none", maxHeight: 315 }}
                    component={Paper}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ minWidth: "125px" }}>
                            <TableSortLabel
                              active={billingStateOrderBy === "ID"}
                              direction={
                                billingStateOrderBy === "ID"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("ID")}
                              IconComponent={() => getLocationSortIcon("ID")}
                              style={
                                billingStateOrderBy === "ID"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Statement ID{" "}
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "BrokerName"}
                              direction={
                                billingStateOrderBy === "BrokerName"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("BrokerName")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("BrokerName")
                              }
                              style={
                                billingStateOrderBy === "BrokerName"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Broker
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>Billing Period</TableCell>
                          <TableCell>
                            {" "}
                            <TableSortLabel
                              active={billingStateOrderBy === "Hours"}
                              direction={
                                billingStateOrderBy === "Hours"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("Hours")}
                              IconComponent={() => getLocationSortIcon("Hours")}
                              style={
                                billingStateOrderBy === "Hours"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Hours
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              sx={{ minWidth: "68px" }}
                              active={billingStateOrderBy === "DayRate"}
                              direction={
                                billingStateOrderBy === "DayRate"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("DayRate")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("DayRate")
                              }
                              style={
                                billingStateOrderBy === "DayRate"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Day Rate
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              sx={{ minWidth: "69px" }}
                              active={billingStateOrderBy === "PerDiem"}
                              direction={
                                billingStateOrderBy === "PerDiem"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("PerDiem")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("PerDiem")
                              }
                              style={
                                billingStateOrderBy === "PerDiem"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Per Diem
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            {" "}
                            <TableSortLabel
                              active={billingStateOrderBy === "Expenses"}
                              direction={
                                billingStateOrderBy === "Expenses"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("Expenses")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("Expenses")
                              }
                              style={
                                billingStateOrderBy === "Expenses"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Expenses
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            {" "}
                            <TableSortLabel
                              active={billingStateOrderBy === "Miles"}
                              direction={
                                billingStateOrderBy === "Miles"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("Miles")}
                              IconComponent={() => getLocationSortIcon("Miles")}
                              style={
                                billingStateOrderBy === "Miles"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Miles
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            {" "}
                            <TableSortLabel
                              active={billingStateOrderBy === "StatusID"}
                              direction={
                                billingStateOrderBy === "StatusID"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("StatusID")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("StatusID")
                              }
                              style={
                                billingStateOrderBy === "StatusID"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Status
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            {" "}
                            <TableSortLabel
                              active={billingStateOrderBy === "Total"}
                              direction={
                                billingStateOrderBy === "Total"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("Total")}
                              IconComponent={() => getLocationSortIcon("Total")}
                              style={
                                billingStateOrderBy === "Total"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Total
                            </TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {/* <TableRow>
                      <TableCell colSpan={7} align="center">
                        <CircularProgress disableShrink />
                      </TableCell>
                    </TableRow> */}
                      <TableBody>
                        {/* Empty Rows */}
                        {sortedLocationList?.map((period, i) => (
                          <TableRow key={i}>
                            <TableCell>{period.ID}</TableCell>
                            <TableCell sx={{ lineBreak: "anywhere" }}>
                              {period.BrokerName}
                            </TableCell>
                            <TableCell>
                              {" "}
                              {`${moment
                                .utc(period.BillingStart)
                                .format("MM/DD/YYYY")} - ${moment
                                .utc(period.BillingEnd)
                                .format("MM/DD/YYYY")}`}
                            </TableCell>
                            <TableCell>
                              {Number(period.Hours).toFixed(2)}
                            </TableCell>
                            <TableCell>
                              ${Number(period.DayRate).toFixed(2)}
                            </TableCell>
                            <TableCell>
                              ${Number(period.PerDiem).toFixed(2)}
                            </TableCell>
                            <TableCell>
                              ${Number(period.Expenses).toFixed(2)}
                            </TableCell>
                            <TableCell>
                              {Number(period.Miles).toFixed(3)}
                            </TableCell>
                            <TableCell>{period?.StatusName}</TableCell>
                            <TableCell>
                              ${Number(period.Total).toFixed(2)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <NoRecordFound />
                )}
              </Grid>
            </Grid>
          </Box>
        ) : (
          !billingStatmentLoading && (
            <Box className="secound-bg-box user-log">
              <Grid container>
                <Box
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    background: "#fff",
                    marginTop: "15px",
                    borderRadius: "5px",
                  }}
                >
                  <img
                    style={{ width: "100%", maxWidth: "326px" }}
                    src={BillingNodata}
                  />
                  <p
                    style={{ marginTop: "15px", marginBottom: "50px" }}
                    className="no-data-text"
                  >
                    Please select a{" "}
                    <span style={{ color: "#58A84A" }}>customer</span> and{" "}
                    <span style={{ color: "#58A84A" }}>project</span> to view
                    the billing statements.
                  </p>
                </Box>
              </Grid>
            </Box>
          )
        )}
      </Box>
    </Box>
  );
};

export default BillingReview;
